import { isNil } from 'lodash';

const CONST_HEIGHTS = Object.freeze({
  customPadding: 0,
  columnBorderHeight: 1,
  footerHeight: 100,
  headerHeight: 41,
  verticalPagePaddings: 35
});
const MEASURED_HEIGHTS = {
  appUserSelectHeight: 62,
  formFilterHeight: 46,
  mbsTableNavHeight: 58
};
const LAYOUT_HEIGHT_CONFIG = Object.assign({}, CONST_HEIGHTS, MEASURED_HEIGHTS);

export function getColumnMaxHeight(overrides: Partial<Record<string, number>> = {}, minHeight = 213): string {
  const values: number[] = [];
  const seen = new Set<string>();

  for (const [key, defaultValue] of Object.entries(LAYOUT_HEIGHT_CONFIG)) {
    seen.add(key);

    const override = overrides[key];
    const shouldSkip = override === 0 || (!isNil(override) && override < 0);

    if (!shouldSkip) {
      const value = override ?? defaultValue;

      if (value > 0) values.push(value);
    }
  }

  for (const [key, value] of Object.entries(overrides)) {
    if (!seen.has(key) && value > 0) values.push(value);
  }

  const subtraction = values.map((value) => ` - ${value}px`).join('');

  return `max(calc(100vh${subtraction}), ${minHeight}px)`;
}
